import { render } from "./App.vue?vue&type=template&id=d52e808a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d52e808a&lang=scss"

import exportComponent from "/home/runner/work/Taiwan_Travel/Taiwan_Travel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__